import { render, staticRenderFns } from "./NoLessonPoints.vue?vue&type=template&id=59e67248&scoped=true&"
import script from "./NoLessonPoints.vue?vue&type=script&lang=js&"
export * from "./NoLessonPoints.vue?vue&type=script&lang=js&"
import style0 from "./NoLessonPoints.vue?vue&type=style&index=0&id=59e67248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e67248",
  null
  
)

export default component.exports